import { defineStore } from 'pinia'

const DEFAULT_PAYLOAD = {
  dates: '',
  childs: 0,
  adults: 1,
}
export interface Payload {
  dates: string
  childs: number
  adults: number
}

export interface UserState {
  payload: Payload
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    payload: DEFAULT_PAYLOAD,
  }),
  getters: {
    getPayload(): UserState['payload'] {
      return this.payload
    },
  },
  actions: {
    async setPayload(payload: Payload) {
      this.payload = payload
    },
  },
})
